import axios from "../_helpers/axiosInstance.js";

const resellerSignup = async (firstName,
                              lastName,
                              email,
                              password,
                              phoneNumber,
                              organizationName,
                              address,
                              city,
                              prov,
                              postCode,
                              country) => {
    const data = {  firstName, lastName, email, password, organizationName, phoneNumber, orgAddress: address,
    orgCity: city, orgProv: prov, orgCountry: country, orgPostCode: postCode, address, city, prov, country, postCode};
    await axios.post('useraccount/reseller', data);
}

const taxAuthSignup = async (inviteKey,
                              firstName,
                              lastName,
                              password,
                              phoneNumber,
                              address,
                              city,
                              postCode,
                              financialContactName,
                              financialContactPhone,
                              financialContactEmail,
                              taxCertificatePrice,
                              techContactName,
                              techContactPhone,
                              techContactEmail
                              ) => {
    const payload = {
        inviteKey,
        firstName,
        lastName,
        password,
        phoneNumber,
        address,
        city,
        postCode,
        financialContactName,
        financialContactPhone,
        financialContactEmail,
        taxCertificatePrice,
        techContactName,
        techContactPhone,
        techContactEmail
    };
    const response = await axios.post('taxAuthority/onboarding/complete', payload);
    return response.data.result;
}
const customerSignup = async (firstName,
                              lastName,
                              email,
                              password,
                              phoneNumber,
                              organization,
                              organizationName,
                              orgType,
                              address,
                              city,
                              prov,
                              postCode,
                              country) => {
    const data = {
        firstName, lastName, email, password, organization: organization === 'true', organizationName, orgType, phoneNumber, orgAddress: address,
        orgCity: city, orgProv: prov, orgCountry: country, orgPostCode: postCode, address, city, prov, country, postCode
    };
    await axios.post('useraccount', data);
}

const activateUserAccount = async (activationKey) => {
    await axios.post(`useraccount/activate/${activationKey}`);
}

const getResellerOnboardingInfo = async (activationKey) => {
    let response = await axios.get(`useraccount/reseller/onboarding/${activationKey}`);
    console.log("onboarding info response: ", response);
    return response.data.result;
}

export const signUpApi = {
    resellerSignup, customerSignup, activateUserAccount, getResellerOnboardingInfo, taxAuthSignup
}
